import React, { PureComponent } from 'react';

interface Props {
  size?: number;
  className?: string;
}

class VisualQueryBuilder extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <rect width="32" height="32" stroke="transparent" />
        <rect
          x="2"
          y="3"
          width="9"
          height="9"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="21"
          y="20"
          width="9"
          height="9"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="7" cy="16" r="1" stroke="currentColor" strokeWidth="2" />

        <circle cx="25" cy="16" r="1" stroke="currentColor" strokeWidth="2" />
        <path
          d="M7 15.5029C7 15.5029 7.52941 21.4676 11.7647 20.9706C16 20.4735 16 11.5265 20.2353 11.0294C24.4706 10.5324 25 16.4971 25 16.4971"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}

export default VisualQueryBuilder;
